/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
//fitvids();

/**
 * Init CSS vars ponyfill
 */
//cssVars({});

( function () {
	( function ( $ ) {
    $.fn.resizeselect = function(settings) {
      return this.each(function(){
          var $this = $(this), numberOfOptions = $(this).children('option').length;
      
          $this.addClass('select-hidden'); 
          $this.wrap('<div class="select"></div>');
          $this.after('<div class="select-styled"></div>');
      
          var $styledSelect = $this.next('div.select-styled');
          $styledSelect.text($this.find(":selected") ? $this.find(":selected").text() : $this.children('option').eq(0).text());
      
          var $list = $('<ul />', {
              'class': 'select-options'
          }).insertAfter($styledSelect);
      
          for (var i = 0; i < numberOfOptions; i++) {
              $('<li />', {
                  text: $this.children('option').eq(i).text(),
                  rel: $this.children('option').eq(i).val(),
                  class: $this.children('option').eq(i).attr('selected') ? 'active' : '',
              }).appendTo($list);
          }
      
          var $listItems = $list.children('li');
      
          $styledSelect.click(function(e) {
              e.stopPropagation();
              $('div.select-styled.active').not(this).each(function(){
                  $(this).removeClass('active').next('ul.select-options').hide();
              });
              $(this).toggleClass('active').next('ul.select-options').toggle();
          });
      
          $listItems.click(function(e) {
              e.stopPropagation();
              $styledSelect.text($(this).text()).removeClass('active');
              $this.val($(this).attr('rel'));
              $list.hide();
              $this.trigger('change');
          });
      
          $(document).click(function() {
              $styledSelect.removeClass('active');
              $list.hide();
          });
      });
    };

    $('#showmore-activities').on('click',function(e){
        e.preventDefault();
        $('.activity.hidden').removeClass('hidden');
        $('.activities').removeClass('has-loadmore');
        $(this).remove();
    });
    $(function(){
        if($('.weather-forecast').length){
            var destination = $('.weather-forecast').data('destination');
            var ajaxuri = $('.weather-forecast').data('ajxuri');
            console.log(destination);
            $.ajax({
                method: 'GET',
                url: ajaxuri,
                data:{ 'destination':destination,'action':'weather_live'},
                dataType: 'html',                
                success: function(response) {
                    $('.weather-forecast').html(response);
                }
            });
        }

        $('a[href*="#"]')
        .not('.image-popup-vertical-fit')
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.popup-modal')
        .not('.tab-link')
        .on('click', function (event) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                if (target.length) {
                    var offset;
                    if(target.hasClass('anchor')){
                        if($('body').hasClass('logged-in')){
                            offset = target.offset().top - 132;
                        }else{
                            offset = target.offset().top - 100;
                        }
                    }else{
                        offset = target.offset().top - 50;
                    }
                    $('html, body').animate({
						scrollTop: offset
					}, 600, function () { });
                }
                return false;
            }
	    });
    });
    if($('.sticky-nav').length){
        $(window).on('scroll',function(){
            if(!$('.sticky-nav').hasClass('bottom')){
                if(($('.sticky-nav').offset().top + 33) >= $('.copyrightbar').offset().top){
                    $('.sticky-nav').addClass('bottom');              
                }
                else{
                    $('.sticky-nav').removeClass('bottom');
                }
            }
            else{
                var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                if(bottom_of_screen < $('.copyrightbar').offset().top){
                    $('.sticky-nav').removeClass('bottom');
                }
            }
        });
    }
  } )( jQuery );    
} )();